<app-filters-checkbox-item
    title="{{ 'components.button.allCommunities' | translate }}"
    [option]="allCommunitiesFilterItem"
    (selectionChange)="onAllCommunitiesSelectionChanged()"
>
</app-filters-checkbox-item>
